export const normalizeAnalyticsKey = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

export const normalizeAnalyticsKeyForLinks = (href: string): string =>
  normalizeAnalyticsKey(href.replace(/^https?:\/\//, "").replace(/\W+/g, " "));
